import { SET_GROUP_STATE } from '../actions/group-actions';

export interface GroupState {
    hidden: boolean;
    locked: boolean;
    color: string;
    labels: number[];
}

export type GroupsState = Record<string, GroupState>;

const initialState: GroupsState = {};

export default function groupsReducer(state = initialState, action: any): GroupsState {
    switch (action.type) {
        case SET_GROUP_STATE: {
            const { groupId, state: newState } = action.payload;
            return {
                ...state,
                [groupId]: {
                    ...state[groupId],
                    ...newState,
                },
            };
        }
        default:
            return state;
    }
}
